/**
 * на страницу с картой добавить тег
    <script src="https://api-maps.yandex.ru/1.1/index.xml" type="text/javascript"></script>
 *
 */

/* eslint-disable no-underscore-dangle */
/* eslint-disable func-names */
/* eslint-disable no-undef */

function GeltekPlaceMarkLayout() {
    const element = YMaps.jQuery(`
        <div class="map-nav__pin">
            <img class="map-nav__pin-img" src="/img/icons/map-pin.svg">
        </div>    
    `);

    this.onAddToParent = function (parentNode) {
        element.appendTo(parentNode);
    };
    this.onRemoveFromParent = function () {
        element.remove();
    };
    this.update = function () { };
    this.getOffset = function () { return new YMaps.Point(-5, -5); };
    this.getRootNodes = function () { return element; };
}

export function GeltekBalloonLayout() {
    this.element = YMaps.jQuery(`
        <div class="map-nav__balloon">
            <div class="content">
            </div>
            <div class="close"></div>
            <div class="tail"></div>
        </div>
    `);

    this.close = this.element.find(".content");
    this.content = this.element.find(".content");

    // Отключает кнопку закрытия балуна
    this.disableClose = function () {
        // this.close.unbind("click").css("display", "none");
    };

    // Включает кнопку закрытия балуна
    this.enableClose = function (callback) {
        this.close.bind("click", callback).css("display", "");

        const links = this.element.find("a");

        links.each(function (e) {
            this.addEventListener("click", function () {
                window.location = this.href;
            });
            this.addEventListener("touchend", function () {
                window.location = this.href;
            });
        });
        this.close.bind("touchend", callback);
        return false;
    };

    // Добавляет макет на страницу
    this.onAddToParent = function (parentNode) {
        YMaps.jQuery(parentNode).append(this.element);
    };

    // Удаляет макет со страницы
    this.onRemoveFromParent = function () {
        this.element.remove();
    };

    // Устанавливает содержимое балуна
    this.setContent = function (content) {
        this.content[0].innerHTML = "";
        content.onAddToParent(this.content[0]);
    };

    this.onClick = function () {
        console.log("onclick");
    };

    this.click = function () {
        console.log("oclick");
    };

    // Обновляет балун
    this.update = function () {

    };
}

// Стиль кастомной метки
function GeltekMapPinStyle() {
    const sampleBalloonTemplate = new YMaps.LayoutTemplate(GeltekBalloonLayout);

    const pinStyle = new YMaps.Style();

    pinStyle.balloonStyle = { template: sampleBalloonTemplate };

    pinStyle.balloonContentStyle = new YMaps.BalloonContentStyle(
        new YMaps.Template(`
            <div class="map-nav__balloon-header">
            $[name]
            </div>
            <div class="map-nav__balloon-description">
            $[description]
            </div>
            <div class="map-nav__balloon-content">
            $[balloonContentBody]
            </div>
        `),
    );

    pinStyle.iconStyle = new YMaps.IconStyle(new YMaps.LayoutTemplate(GeltekPlaceMarkLayout));

    return pinStyle;
}

// Стиль кастомного баллуна
export function GeltekBalloonStyle() {
    const sampleBalloonTemplate = new YMaps.LayoutTemplate(GeltekBalloonLayout);

    const balloonStyle = new YMaps.Style();

    balloonStyle.balloonContentStyle = new YMaps.BalloonContentStyle(
        new YMaps.Template("<div style=\"color:#0A0\">$[description]</div>"),
    );

    balloonStyle.balloonStyle = { template: sampleBalloonTemplate };

    return balloonStyle;
}

// Кастомная панель навигации
export function Navigation() {
    this.onAddToMap = function (map, position) {
        this.container = YMaps.jQuery("<ul class='map-nav'></ul>");

        this.map = map;

        this.position = position || new YMaps.ControlPosition(
            YMaps.ControlPosition.TOP_RIGHT,
            new YMaps.Size(36, 124),
        );

        this.generateZoomInBtn();

        this.generateZoomOutBtn();

        this.generateGeolocationBtn();

        // Добавляет элемент управления на карту
        this.container.appendTo(this.map.getContainer());
    };

    // Создает кнопку увеличения масштаба
    this.generateZoomInBtn = function () {
        const _this = this;

        const button = YMaps.jQuery(`
            <button class="map-nav__btn map-nav__plus">
                <i class="icon icon-plus"></i>
            </button>    
        `);

        button.bind("click", () => {
            const currZoom = _this.map.getZoom();
            _this.map.setZoom(currZoom + 1);
        });

        button.appendTo(_this.container);
    };

    // Создает кнопку уменьшения масштаба
    this.generateZoomOutBtn = function () {
        const _this = this;

        const button = YMaps.jQuery(`
            <button class="map-nav__btn map-nav__minus">
                <i class="icon icon-minus"></i>
            </button>    
        `);

        button.bind("click", () => {
            const currZoom = _this.map.getZoom();
            _this.map.setZoom(currZoom - 1);
        });

        button.appendTo(_this.container);
    };

    // Создает кнопку перехода к текущей геолокации
    this.generateGeolocationBtn = function () {
        const _this = this;

        const button = YMaps.jQuery(`
            <button class="map-nav__btn map-nav__geolocation">
                <i class="icon icon-map-geolocation"></i>
            </button>    
        `);

        button.bind("click", () => {
            if (YMaps.location) {
                const center = new YMaps.GeoPoint(
                    YMaps.location.longitude,
                    YMaps.location.latitude,
                );

                _this.map.openBalloon(center, `Место вашего предположительного местоположения:<br/>${YMaps.location.country || ""
                }${YMaps.location.region ? `, ${YMaps.location.region}` : ""
                }${YMaps.location.city ? `, ${YMaps.location.city}` : ""}`);
            }
        });

        button.appendTo(_this.container);
    };

    this.onRemoveFromMap = function () {
        if (this.container.parent()) {
            this.container.remove();
            this.container = null;
        }
        this.map = null;
    };
}

/**
 * @typedef
 * {[longitude:number, latitude:number]} Coords
 */

/**
 *
 * @param {string} mapContainerSelector - селекотор контейнера для карты
 * @param {{
 *  center: Coords,
 *  zoom: number
 * }} options - начальные параметры: координаты([ширина, долгота]) и масштаб
 */
export function BaseYMap(mapContainerSelector, options) {
    this.map = null;

    YMaps.jQuery(() => {
        this.map = new YMaps.Map(YMaps.jQuery(mapContainerSelector)[0]);

        // Устанавливает начальные параметры отображения карты:
        // центр карты и коэффициент масштабирования
        if (options) this.map.setCenter(new YMaps.GeoPoint(...options.center.slice().reverse()), options.zoom);

        // Добавляет кастомную панель навигации
        this.map.addControl(new Navigation());

        this.setCenter = (center, zoom = 17) => {
            this.map.setCenter(new YMaps.GeoPoint(...center.slice().reverse()), zoom);
        };

        /**
         *
         * @param {Coords} coords - Координаты
         * @param {{name: string, description:string, content:string}} content - Координаты
         * @param {any} pinStyle - Стиль метки(опционально)
         */
        this.addMark = (coords, content = { name: "", description: "", content: "" }, pinStyle = new GeltekMapPinStyle()) => {
            if (!this.map) return null;

            const placemark = new YMaps.Placemark(new YMaps.GeoPoint(...coords.slice().reverse()), {
                style: pinStyle,
                balloonContentHeader: "The placemark balloon",
            });

            placemark.name = content.name;

            placemark.description = content.description;

            placemark.balloonContentBody = content.content;

            this.map.addOverlay(placemark);

            return placemark;
        };

        /**
         * @param {Coords} coords - Координаты
         * @param {string} description - Текст баллуна
         * @param {any} balloonStyle - Стиль баллуна(опционально)
         */
        this.addBallon = (coords, description, balloonStyle = new GeltekBalloonStyle()) => {
            const placemark = new YMaps.Placemark(
                new YMaps.GeoPoint(...coords),
                { style: balloonStyle },
            );
            placemark.description = description;

            this.map.addOverlay(placemark);

            placemark.openBalloon();

            return placemark;
        };
    });
}

function GeltekPlaceMarkLayoutV2() {
    return ymaps.templateLayoutFactory.createClass(`
        <div class="map-nav__pin">
            <img class="map-nav__pin-img" src="/img/icons/map-pin.svg" alt="Map Pin">
        </div>
    `);
}

function GeltekMapPinStyleV2() {
    const customPinLayout = GeltekPlaceMarkLayoutV2();

    return {
        iconLayout: customPinLayout, // Устанавливаем кастомный макет
        iconShape: {
            type: "Rectangle",
            coordinates: [
                [-25, -25], [25, 25],
            ],
        },

        // Настраиваем балун
        balloonLayout: ymaps.templateLayoutFactory.createClass(`
            <div class="map-nav__balloon">
                <h3 class="map-nav__balloon-header">$[properties.name]</h3>
                <div class="map-nav__balloon-description">$[properties.description]</div>
                <div class="map-nav__balloon-content">$[properties.content]</div>
            </div>
        `),
        balloonContentLayout: ymaps.templateLayoutFactory.createClass(`
            <div class="map-nav__balloon">
                <h3 class="map-nav__balloon-header">$[properties.name]</h3>
                <div class="map-nav__balloon-description">$[properties.description]</div>
                <div class="map-nav__balloon-content">$[properties.content]</div>
            </div>
        `),
        hideIconOnBalloonOpen: false, // Показываем значок, когда балун открыт
    };
}

// Функция для создания кастомного layout панели управления
function createCustomZoomControlLayoutV2() {
    return ymaps.templateLayoutFactory.createClass(`
        <div class='map-nav'>
            <button class="map-nav__btn map-nav__plus">
                <i class="icon icon-plus"></i>
            </button>  
            <button class="map-nav__btn map-nav__minus">
                <i class="icon icon-minus"></i>
            </button> 
            <button class="map-nav__btn map-nav__geolocation">
                <i class="icon icon-map-geolocation"></i>
            </button> 
        </div>
    `, {
        build() {
            this.constructor.superclass.build.call(this);

            const zoomInButton = this.getElement().querySelector(".map-nav__plus");
            const zoomOutButton = this.getElement().querySelector(".map-nav__minus");
            const geoButton = this.getElement().querySelector(".map-nav__geolocation");

            zoomInButton.addEventListener("click", this._onZoomInClick.bind(this));
            zoomOutButton.addEventListener("click", this._onZoomOutClick.bind(this));
            geoButton.addEventListener("click", this._onGeoClick.bind(this));
        },

        clear() {
            const zoomInButton = this.getElement().querySelector(".map-nav__plus");
            const zoomOutButton = this.getElement().querySelector(".map-nav__minus");
            const geoButton = this.getElement().querySelector(".map-nav__geolocation");

            zoomInButton.removeEventListener("click", this._onZoomInClick.bind(this));
            zoomOutButton.removeEventListener("click", this._onZoomOutClick.bind(this));
            geoButton.removeEventListener("click", this._onGeoClick.bind(this));

            this.constructor.superclass.clear.call(this);
        },

        _onZoomInClick() {
            const map = this.getData().control.getMap();
            map.setZoom(map.getZoom() + 1);
        },

        _onZoomOutClick() {
            const map = this.getData().control.getMap();
            map.setZoom(map.getZoom() - 1);
        },

        _onGeoClick() {
            const map = this.getData().control.getMap();
            ymaps.geolocation.get({
                provider: "browser",
                mapStateAutoApply: true,
            })
                .then((result) => {
                    const userLocation = result.geoObjects.get(0).geometry.getCoordinates();
                    const address = result.geoObjects.get(0).properties.get("text");
                    map.panTo(userLocation, { flying: true });
                    map.balloon.open(userLocation, `Ваше местоположение: ${address}`);
                })
                .catch(() => {
                    alert("Не удалось определить местоположение. Убедитесь, что геолокация включена.");
                });
        },
    });
}

function drawRoutesToDestinations(startCoords, destinations, map) {
    const colorList = ["0066ff", "ff3333", "548f57", "ea7ed7"];

    destinations.forEach((destination, destinationIndex) => {
        const multiRoute = new ymaps.multiRouter.MultiRoute(
            {
                // Точки маршрута: начальная и конечная
                referencePoints: [startCoords, destination.coordinates],
                params: {
                    results: 1, // Один маршрут
                    routingMode: "pedestrian",
                },
            },
            {
                routeActiveStrokeColor: colorList[destinationIndex],
                routeStrokeWidth: 4, // Толщина линии маршрута
                routeActiveStrokeWidth: 6, // Толщина активного маршрута
                wayPointStartIconColor: "transparent", // Прозрачная иконка для начальной точки
                wayPointFinishIconColor: "transparent", // Прозрачная иконка для конечной точки
                wayPointStartVisible: false, // Скрывает начальную точку
                wayPointFinishVisible: false, // Скрывает конечную точку
            },
        );

        map.geoObjects.add(multiRoute);
    });
}

/**
 *
 * @param {string} mapContainerSelector - селекотор контейнера для карты
 * @param {{
*  center: Coords,
*  zoom: number
* }} options - начальные параметры: координаты([ширина, долгота]) и масштаб
*/
export function BaseYMapV2(mapContainerSelector, options) {
    this.map = null;

    ymaps.ready(() => {
        this.map = new ymaps.Map(mapContainerSelector, {
            center: [55.751574, 37.573856],
            zoom: 10,
            controls: [], // Убираем стандартные элементы управления
        });

        // создание кастомной панели управления
        const CustomZoomControlLayout = createCustomZoomControlLayoutV2();

        const customZoomControl = new ymaps.control.ZoomControl({
            options: {
                layout: CustomZoomControlLayout,
                position: {
                    top: "100%",
                    right: 50,
                },
            },
        });

        this.map.controls.add(customZoomControl);

        // Метод для изменения центра карты
        this.setCenter = (center, zoom = 17) => {
            if (this.map) {
                this.map.setCenter(center, zoom, { checkZoomRange: true });
            } else {
                console.warn("Карта еще не инициализирована. Попробуйте позже.");
            }
        };

        /**
         *
         * @param {Coords} coords - Координаты
         * @param {{name: string, description:string, content:string}} content - Координаты
         * @param {any} pinStyle - Стиль метки(опционально)
         * @description добавление метки на карту
         */
        this.addMark = (coords, content = { name: "", description: "", content: "" }, pinStyle = GeltekMapPinStyleV2()) => {
            if (!this.map) return null;

            const placemark = new ymaps.Placemark(coords, {
                name: content.name,
                description: content.description,
                content: content.content,
            }, pinStyle);

            this.map.geoObjects.add(placemark);

            // findNearbyMetrosAndDrawRoutes(coords, this.map);

            return placemark;
        };

        /**
         * @param {Coords} startCoords
         * @param {{coordinates:Coords}[]} destinations
         */
        this.addMultiRoute = (startCoords, destinations) => {
            drawRoutesToDestinations(startCoords, destinations, this.map);
        };
    });
}
